module.exports = __webpack_public_path__ + "img/Managedservices-c.71653ff.svg";